import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/users/team-memberships';

export const FETCH_TEAM_MEMBERSHIP = defineApiActionTypes(`${prefix}/FETCH_TEAM_MEMBERSHIP`);

export const FETCH_TEAM_MEMBERSHIPS_BY_USER_ID = defineApiActionTypes(`${prefix}/FETCH_BY_USER_ID`);

export const SHOW_ACCEPT_TEAM_MEMBERSHIP_INSTRUCTIONS = `${prefix}/SHOW_ACCEPT_TEAM_MEMBERSHIP_MEMBER_INSTRUCTIONS`;
export const CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS = defineApiActionTypes(
  `${prefix}/CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS`
);
export const ACCEPT_TEAM_MEMBERSHIP = defineApiActionTypes(`${prefix}/ACCEPT_TEAM_MEMBERSHIP`);

export const REJECT_TEAM_MEMBERSHIP = defineApiActionTypes(`${prefix}/REJECT_TEAM_MEMBERSHIP`);

export const SHOW_REVOKE_TEAM_MEMBERSHIP_INSTRUCTIONS = `${prefix}/SHOW_REVOKE_TEAM_MEMBERSHIP_INSTRUCTIONS`;
export const REVOKE_TEAM_MEMBERSHIP = defineApiActionTypes(`${prefix}/REVOKE_TEAM_MEMBERSHIP`);

export const POLL_TEAM_MEMBERSHIP = {
  START: `${prefix}/POLL_TEAM_MEMBERSHIP_START`,
  STOP: `${prefix}/POLL_TEAM_MEMBERSHIP_STOP`,
};



// WEBPACK FOOTER //
// ./src/store/features/users/team-memberships/action-types.js